/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable no-script-url */
/* eslint-disable no-useless-constructor */
/**
 * @fileOverview ImageUploader erradeng
 * @author erradeng
 * @time Wed Apr 25 2018 12:31:02 GMT+0800 (CST)
 * @module ImageUploader
 * @example
 * import ImageUploader from '@tencent/ImageUploader';
 * import '@tencent/ImageUploader/lib/index.css';
 *
 * &lt;ImageUploader {...this.props} /&gt;
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import enlargepic from '@/utils/enlargepic';

/**
 * @class
 */
class ImageUploader extends PureComponent {
  constructor(props) {
    super(props);
  }

  /**
   * 属性说明
   * @property {string} text='' 文案
   */
  enlarge(url) {
    enlargepic.show(url);
  }

  delete(name) {
    if (name) {
      this.props.onFileDelete(name);
    }
  }

  resizeImg(event) {
    const $ = window.jQuery || '';
    let $this = null;
    let $parent = null;
    const imgSize = {};
    let imgRatio = 0;
    const parentSize = {};
    let parentRatio = 0;

    if (!$) {
      return false;
    }

    $this = $(event.target);
    $parent = $this.parent();

    if ($this.length > 0 && $parent.length > 0) {
      imgSize.width = $this.width();
      imgSize.height = $this.height();
      parentSize.width = $parent.innerWidth();
      parentSize.height = $parent.innerHeight();

      imgRatio = imgSize.width / imgSize.height;
      parentRatio = parentSize.width / parentSize.height;

      if (parentRatio < imgRatio) {
        $this.css('height', '100%');
        $this.css('left', -parseInt(Math.abs((parentSize.width - (imgSize.width * parentSize.height) / imgSize.height) / 2)));
      } else {
        $this.css('width', '100%');
        $this.css('top', -parseInt(Math.abs((parentSize.height - (imgSize.height * parentSize.width) / imgSize.width) / 2)));
      }
    }
  }

  render() {
    const { className = '', wrapClassName = '', areaClassName = '', listClassName = '', moreDataClassName = '', itemClassName = 'upfile', resizeImageAble = true, enlargeable = true, AddComponent: propsAddComponent, setImageUrl, disabled = false } = this.props;

    const data = this.props.data || [];
    const limit = parseInt(this.props.limit != undefined ? this.props.limit : 1);
    const show = this.props.show || false;
    let isLimit = true;
    let randomNum;
    let inputs = '';
    const imgProps = {};

    const inputFileStyle = {
      opacity: '0',
      display: 'none',
      width: 0,
      height: 0,
    };

    const id = this.props.fileId;

    const defaultAddComponent = (props) => {
      const { id } = props;

      return (
        <label htmlFor={id}>
          <div className="upfile add-file">
            <i className="ico-addfile"></i>
          </div>
        </label>
      );
    };
    const AddComponent = propsAddComponent || defaultAddComponent;
    const _setImageUrl =      setImageUrl
      || function (item = {}) {
        return item.url || '';
      };

    if (data.length < limit) {
      isLimit = false;
    }

    if (!isLimit && !this.props.isRange) {
      inputs = (
        <span>
          <input type="file" style={inputFileStyle} name="img" id={id} onChange={this.props.onFileChange} />
        </span>
      );
    }

    if (resizeImageAble) {
      imgProps.onLoad = (event) => {
        this.resizeImg(event);
      };
    } else {
      imgProps.width = '100%';
      imgProps.height = '100%';
    }

    const innerComp =      data.length > 0 ? (
        <div className={`${listClassName} ${limit > 1 ? moreDataClassName : ''}`}>
          {data.map((item, index) => (
            <div key={index} className={(limit == 1 ? 'bus-license ' : 'icp-license ') + itemClassName}>
              <img src={_setImageUrl(item)} {...imgProps} />
              {enlargeable ? (
                <i className="ico-enlarge" onClick={() => this.enlarge(item.url)}>
                  放大
                </i>
              ) : null}
              <div className="marker">
                {!show && !disabled ? (
                  <a href="javascript:;" className="del" onClick={() => this.delete(item.id)}>
                    删除
                  </a>
                ) : (
                  ''
                )}
              </div>
            </div>
          ))}

          {isLimit || disabled ? '' : <AddComponent id={id} />}
        </div>
    ) : (
        <label key={id} htmlFor={id}>
          {this.props.children}
        </label>
    );

    const middleComp = [];
    middleComp.push(innerComp);
    middleComp.push(inputs);

    return (
      <div className={`${'upload-panel clearfix' + ' '}${className}`} id={this.props.panelId} style={this.props.style}>
        <div onDragEnter={this.props.onFileChange} onDragOver={this.props.onFileChange} onDrop={this.props.onFileChange} className={`${'picWrapper' + ' '}${wrapClassName}`}>
          {areaClassName ? <div className={areaClassName}>{middleComp}</div> : middleComp}
        </div>
      </div>
    );
  }
}

ImageUploader.propTypes = {
  data: PropTypes.array.isRequired, // image data : array of objects (url & id)
  fileId: PropTypes.string.isRequired, // file input dom's id
  limit: PropTypes.number, // limit of images allowed, default to 1
  onFileChange: PropTypes.func, // cb of file change event
  onFileDelete: PropTypes.func, // cb of file deletion event
  panelId: PropTypes.string, // panel block id
  isRange: PropTypes.bool, // 是不是range类型的，如果为true则不会有file input dom
  disabled: PropTypes.bool, // 是否禁用
};

export default ImageUploader;
